export var fontWeights = {
    normal: 400,
    medium: 500,
    bold: 700,
    extraBold: 800,
};
export var lineHeights = {
    base: '1.5',
};
export var colors = {
    primary: '#153255',
    secondary: '#ffffff',
    inactive: '#879da8',
    lessImportant: '#63808e',
    textLink: '#38afa2',
    error: '#ff4c4c',
    backgrounds: {
        primary: '#96c8be',
        secondary: '#edd5db',
        tertiary: '#ffedc3',
        error: '#ffecec',
    },
    ctaButton: {
        text: '#ffffff',
        background: 'linear-gradient(to right, #E86800 -14%, 10%, #F00A71 80%, #FF0000 104%)',
        hover: 'linear-gradient(to right, #ff8726 -14%, 10%, #f74092 80%, #ff3d3d 104%)',
        animationGradient: 'linear-gradient(to right, transparent, 20%, rgb(232 104 0 / 80%), 85%, transparent 100%)',
        pressed: 'linear-gradient(90deg, #84c5e2, #a0b3e2, #bda9e2, #cbabe2, #e2b7e2, #e0cce2)',
        shadow: '#b0afaf',
    },
    status: {
        normal: '#c8d9f0',
        success: '#96c8be',
        warning: '#ffedc3',
        error: '#edd5db',
        info: '#c8d9f0',
    },
    statusTag: {
        completed: '#96c8be',
        important: '#edd5db',
        optional: '#e8eeee',
        advertising: '#ffedc3',
        comingSoon: '#ffedc3',
        recommended: '#edd5db',
        incompleted: '#e8eeee',
        active: '#96c8be',
        inActive: '#ffedc3',
        inProgress: '#e8eeee',
    },
    validation: {
        error: '#ff4c4c',
        success: '#4E9500',
    },
    ratingStar: '#f2b134',
    transparent: 'transparent',
    selectedGray: '#979797',
    lightGray: '#f5f5f5',
    gray2: '#aaaaaa',
    gray: '#cccccc',
    gray3: '#d8d8d8',
    gray4: '#dfe4e4',
    gray5: '#828282',
    gray6: '#9DA9B8',
    darkGray: '#999999',
    lighterGray: '#555',
    darkGrayTurquoise: '#637877',
    lightBlack: '#111111',
    lighterBlack: '#555555',
    mediumBlack: '#222',
    yellow: '#f2b134',
    planHeader: '#8fa8a6',
    white: '#ffffff',
    white2: '#fafafa',
    white3: '#e0e0e0',
    black: '#000000',
    green: '#4E9500',
    red: '#de2a2a',
    backgroundPrimary: '#f3f3f3',
    backgroundSecondary: '#dfe3e3',
    placeholder: '#777',
    pink: '#ff6490',
    backgroundYellow: '#ffedc3',
    plainRed: '#FF303B',
};
//# sourceMappingURL=index.js.map